export default __webpack_public_path__ + "static/media/duongnhan6.b22a661d.png";